import { render, staticRenderFns } from "./HelpHome.vue?vue&type=template&id=defa467e&scoped=true"
import script from "./HelpHome.vue?vue&type=script&lang=js"
export * from "./HelpHome.vue?vue&type=script&lang=js"
import style0 from "./HelpHome.vue?vue&type=style&index=0&id=defa467e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "defa467e",
  null
  
)

export default component.exports